import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import TagSelect from './TagSelect';
import NewsPrimary from './NewsPrimary';
import NewsBlock from './NewsBlock';
import NewsList from './NewsList';
import LinkBack from '../widgets/LinkBack';

import './news-template.scss';

const params = {
  '/analyze/actually/': {
    title: 'Публикации',
    subnavigationTitle: 'Анализируем',
    subnavigationLink: '/analyze/subnavigation/'
  },
  '/we/news/': {
    title: 'Новости',
    subnavigationTitle: 'Мы',
    subnavigationLink: '/we/subnavigation/'
  }
};

class NewsTemplate extends PureComponent {
  render() {
    const content = params[this.props.pathname];

    return (
      <div className="news">
        <Helmet>
          <title>{content.title}</title>
        </Helmet>

        <div className="container">
          <div className="news-row">
            <div className="news-col">
              <div className="news-head">
                {(this.props.listView) &&
                  <LinkBack link={this.props.pathname}>
                    {content.title} <i>вернуться</i>
                  </LinkBack>
                }

                {(!this.props.listView) &&
                  <LinkBack link={content.subnavigationLink}>
                    {content.subnavigationTitle} <i>вернуться</i>
                  </LinkBack>
                }

                <div className="news-head-right">
                  {(!this.props.listView) &&
                    <LinkBack
                      direction="right"
                      onClick={this.props.onListViewClick}
                    >
                      {content.title} <i>архив</i>
                    </LinkBack>
                  }

                  <TagSelect
                    tags={this.props.tags}
                    opened={this.props.tagsOpened}
                    onTagClick={this.props.onTagClick}
                    onSearchClick={this.props.onSearchClick}
                    onResetClick={this.props.onResetClick}
                    onTagsToggle={this.props.onTagsToggle}
                  />
                </div>
              </div>

              <h1>{content.title}</h1>

              <div className="news-main">
                {(!!this.props.posts.primaryPost && !this.props.listView) &&
                  <NewsPrimary
                    content={this.props.posts.primaryPost}
                    pathname={this.props.pathname}
                  />
                }

                {(this.props.listView) &&
                  <NewsList
                    pathname={this.props.pathname}
                    items={this.props.postsSearch.results}
                    isFetching={this.props.postsSearch.isFetching}
                    hasMore={!!this.props.postsSearch.next}
                    loadMore={this.props.onLoadMore}
                  />
                }
              </div>
            </div>

            <div className="news-col">
              <NewsBlock
                pathname={this.props.pathname}
                secondaryPost={this.props.posts.secondaryPost}
                posts={this.props.posts.results}
                listView={this.props.listView}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NewsTemplate.propTypes = {
  pathname: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.object),
  tagsOpened: PropTypes.bool,
  posts: PropTypes.shape({
    primaryPost: PropTypes.object,
    secondaryPost: PropTypes.object,
    results: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  postsSearch: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  listView: PropTypes.bool,
  onListViewClick: PropTypes.func,
  onTagClick: PropTypes.func,
  onSearchClick: PropTypes.func,
  onResetClick: PropTypes.func,
  onTagsToggle: PropTypes.func,
  onLoadMore: PropTypes.func
};

export default NewsTemplate;



// WEBPACK FOOTER //
// ./src/components/News/NewsTemplate.js